import { styled } from "@mui/material"

export const Card = styled("section")({
  borderRadius: "4px", height: "auto", overflow: "hidden"
})

export const CardHeader = styled("header")({
  width: "100%", padding: "18px 24px",
})

export const CardContent = styled("article")({
  padding: "20px 40px 24px 40px", display: "grid", rowGap: "20px"
})
